import { AdminExpertsTable } from './AdminExpertsTable';

export default AdminExpertsTable;
